module.exports = __webpack_public_path__ + "static/media/21ECLAC33.ebbdbfa6.jpg";